import React from "react";

import Utilities from "../../foundation/Utility";
import ReactTooltip from "react-tooltip";
import { Alignment } from "../../types/system/Layout";

interface CheckboxProps {
    id?: string;
    label?: string;
    value?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    className?: string;
    tooltip?: string | null;
    tooltipPlace?: string;
    tristate?: boolean;
    alignment?: Alignment;
    onChange?: (value?: boolean) => void;
}

interface CheckboxState {
    ref: React.RefObject<HTMLInputElement>;
}

class Checkbox extends React.Component<CheckboxProps, CheckboxState> {
    state: CheckboxState = {
        ref: React.createRef<HTMLInputElement>(),
    };

    componentDidMount(): void {
        ReactTooltip.rebuild();
    }

    focus() {
        this.state.ref.current?.focus();
    }

    toggleTristate() {
        if (this.props.tristate) {
            const currentValue = this.props.value;
            const newValue =
                currentValue === true
                    ? false
                    : currentValue === false
                    ? null
                    : true;
            this.props.onChange?.(newValue ?? undefined);
        } else {
            this.props.onChange?.(!this.props.value);
        }
    }

    render(): React.ReactNode {
        let classes = "checkbox";

        if (this.props.className) classes += " " + this.props.className;
        if (this.props.tristate && Utilities.isNull(this.props.value))
            classes += " is-null";

        switch (this.props.alignment) {
            case Alignment.Left:
                classes += " left";
                break;
            case Alignment.Right:
                classes += " right";
                break;
            case Alignment.Center:
                classes += " center";
                break;
        }

        return (
            <label
                className={classes}
                data-html={true}
                data-tip={this.props.tooltip}
                data-place={this.props.tooltipPlace}>
                <input
                    id={this.props.id}
                    ref={this.state.ref}
                    type="checkbox"
                    tabIndex={0}
                    checked={this.props.value ?? false}
                    disabled={this.props.disabled === true}
                    readOnly={this.props.readonly === true}
                    onChange={this.toggleTristate.bind(this)}
                />
                <span
                    className="checkmark"
                />
                {this.props.label && (
                    <span className="text">{this.props.label}</span>
                )}
            </label>
        );
    }
}

export default Checkbox;
